<div class="{{DividerClass}}"></div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/divider/divider.html